import Vue from 'vue'
import ImgShow from './index.vue'

const ImgShowConstractor=Vue.extend(ImgShow)
const instance=new ImgShowConstractor()
instance.$mount()
document.body.appendChild(instance.$el) // 将dom插入body

const index=(src)=>{
  if(!src){
    return
  }

  instance.src=src
  console.log(instance.src)
  instance.isShow=true
  return instance
}

export default {
  install:Vue=>{

    Vue.prototype.$showImg=index
  }
}
